<template>
  <div >
    <!-- Features -->
    <SectionList 
      v-if="features.length" 
      title="Features" 
      :items="features" 
    />

    <!-- Bug Fixes -->
    <SectionList 
      v-if="fix.length" 
      title="Bug Fixes" 
      :items="fix" 
    />

    <!-- Known Issues -->
    <SectionList 
      v-if="issues.length" 
      title="Known Issues" 
      :items="issues" 
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import SectionList from "./SectionList.vue";

const props = defineProps({
  title: {
    type: String,
    default: "Section Title"
  },
   features: {
    type: Array,
    default: []
  },
  fix: {
    type: Array,
    default: []
  },
  issues: {
    type: Array,
    default: []
  }

});

</script>

<style scoped>
.version-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 16px;
  background: #fff;
}

.version-title {
  margin-bottom: 12px;
  font-size: 20px;
}
</style>
